import { render, staticRenderFns } from "./HomePageSVG.vue?vue&type=template&id=0976627e&"
import script from "./HomePageSVG.vue?vue&type=script&lang=js&"
export * from "./HomePageSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports